import { useMemo } from 'react';
import { useDrop } from 'react-dnd';

import { useTranslation } from '@mint-lib/i18n';

import { Box } from '@myn/mui';

import {
  BUILDER_ROW_TYPES,
  DRAG_ROW_TYPE,
} from '../../../constants/campaignBuilder.js';
import { dragItemTypes } from '../../../constants/myCampaigns.js';
import { useGetMediaPlanRows } from '../../../hooks/useGetMediaPlanRows.js';
import { useIsArchivedVersion } from '../../../hooks/useIsArchivedVersion.js';
import { MediaPlanRow } from '../../../types/campaignBuilder.js';
import { DragItemRow } from './DragItemRow.jsx';

const TileRow = () => {
  const { t } = useTranslation('@myn/planning');

  const preparedMediaPlanRows = useGetMediaPlanRows();
  const [isArchivedVersion] = useIsArchivedVersion();

  const isPlatformAdded = useMemo(
    () =>
      !!preparedMediaPlanRows.find(
        (mediaPlan: MediaPlanRow) => mediaPlan?.subRows?.length,
      ),

    [preparedMediaPlanRows],
  );
  const [, drop] = useDrop({
    accept: [DRAG_ROW_TYPE, dragItemTypes.ADD_ROW],
  });

  return (
    <Box
      // @ts-expect-error wrong type in library
      ref={drop}
    >
      <DragItemRow
        row={{
          name: 'row',
          label: t('Media Row'),
          rowType: BUILDER_ROW_TYPES.TILE,
        }}
        withoutIcon
        inverted={!isPlatformAdded || isArchivedVersion}
        type={dragItemTypes.ADD_TILE}
      />
    </Box>
  );
};

export default TileRow;
